import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptystateNoTable = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 138,
	height: 138,
	viewBox: "0 0 138 138",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 69,
			cy: 69,
			r: 69,
			fill: "var(--mantine-color-ldGray-1)",
			opacity: .7
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .7,
			d: "M17.5 23.1538C17.5 21.0692 18.9595 19.5 20.6207 19.5H118.379C120.041 19.5 121.5 21.0692 121.5 23.1538V41.8462C121.5 43.9308 120.041 45.5 118.379 45.5H20.6207C18.9595 45.5 17.5 43.9308 17.5 41.8462V23.1538Z",
			fill: "var(--mantine-color-background-0)",
			stroke: "var(--mantine-color-ldGray-4)"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .7,
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M40 25.9375L26 25.9375C25.4 25.9375 25 26.4062 25 26.875L25 38.125C25 38.6875 25.4 39.0625 26 39.0625H40C40.6 39.0625 41 38.6875 41 38.125V26.875C41 26.4063 40.6 25.9375 40 25.9375V25.9375ZM31 37.1875H27V35.3125H31V37.1875V37.1875ZM31 34.375H27L27 32.5H31L31 34.375V34.375ZM31 31.5625H27V29.6875H31V31.5625V31.5625ZM39 37.1875H32V35.3125H39V37.1875V37.1875ZM39 34.375H32L32 32.5H39V34.375V34.375ZM39 31.5625L32 31.5625V29.6875L39 29.6875V31.5625V31.5625Z",
				fill: "var(--mantine-color-ldGray-4)"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .7,
			x: 48,
			y: 30,
			width: 58,
			height: 5,
			rx: 2.5,
			fill: "var(--mantine-color-ldGray-4)",
			fillOpacity: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .7,
			d: "M17.5 58.1538C17.5 56.0692 18.9595 54.5 20.6207 54.5H118.379C120.041 54.5 121.5 56.0692 121.5 58.1538V76.8462C121.5 78.9308 120.041 80.5 118.379 80.5H20.6207C18.9595 80.5 17.5 78.9308 17.5 76.8462V58.1538Z",
			fill: "var(--mantine-color-background-0)",
			stroke: "#848D94"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .7,
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M40 60.9375H26C25.4 60.9375 25 61.4062 25 61.875L25 73.125C25 73.6875 25.4 74.0625 26 74.0625H40C40.6 74.0625 41 73.6875 41 73.125V61.875C41 61.4062 40.6 60.9375 40 60.9375V60.9375ZM31 72.1875H27V70.3125H31V72.1875V72.1875ZM31 69.375H27L27 67.5H31L31 69.375V69.375ZM31 66.5625H27V64.6875H31V66.5625V66.5625ZM39 72.1875H32V70.3125H39V72.1875V72.1875ZM39 69.375H32L32 67.5H39V69.375V69.375ZM39 66.5625H32V64.6875H39V66.5625V66.5625Z",
				fill: "var(--mantine-color-ldGray-6)"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .7,
			x: 48,
			y: 65,
			width: 58,
			height: 5,
			rx: 2.5,
			fill: "var(--mantine-color-ldGray-6)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .7,
			d: "M17.5 93.1538C17.5 91.0692 18.9595 89.5 20.6207 89.5H118.379C120.041 89.5 121.5 91.0692 121.5 93.1538V111.846C121.5 113.931 120.041 115.5 118.379 115.5H20.6207C18.9595 115.5 17.5 113.931 17.5 111.846V93.1538Z",
			fill: "var(--mantine-color-background-0)",
			stroke: "var(--mantine-color-ldGray-4)"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .7,
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M40 95.9375H26C25.4 95.9375 25 96.4062 25 96.875L25 108.125C25 108.688 25.4 109.062 26 109.062H40C40.6 109.062 41 108.688 41 108.125V96.875C41 96.4062 40.6 95.9375 40 95.9375V95.9375ZM31 107.188H27V105.312H31V107.188V107.188ZM31 104.375H27L27 102.5H31L31 104.375V104.375ZM31 101.562H27V99.6875H31V101.562V101.562ZM39 107.188H32V105.312H39V107.188V107.188ZM39 104.375H32L32 102.5H39V104.375V104.375ZM39 101.562H32V99.6875H39V101.562V101.562Z",
				fill: "var(--mantine-color-ldGray-4)"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .7,
			x: 48,
			y: 100,
			width: 58,
			height: 5,
			rx: 2.5,
			fill: "var(--mantine-color-ldGray-4)",
			fillOpacity: .6
		})
	]
});
export default SvgEmptystateNoTable;
